import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import Navigation from "../../components/Navigation";
import Footer from "../../components/Footer";
import { Btn } from "../../components/Button";
import {
    deleteClub,
  getAllClub,
  getUserByDocument,
  updateClub,
} from "../../lib/actions";
import { toast } from "sonner";
import {
  DeleteConfirmationModal,
  UpdateClubModal,
} from "../../components/modals/Modals";
import { useAuth } from "../../context/AuthContext";
import { LoaderIcon } from "../../components/svg/Icons";

const Section = styled.section`
  min-height: ${(props) => `calc(100vh - ${props.theme.navHeight})`};
  width: 100vw;
  position: relative;
  background-color: ${(props) => props.theme.body};
`;

const Container = styled.div`
  width: 80%;
  min-height: 50vh;
  margin: 0 auto;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;

  @media (max-width: 64em) {
    width: 85%;
  }
  @media (max-width: 48em) {
    width: 100%;
  }
`;

const Container2 = styled.div`
  width: 80%;
  min-height: 130vh;
  margin: 0 auto;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;

  @media (max-width: 64em) {
    width: 85%;
  }
  @media (max-width: 48em) {
    width: 100%;
  }
`;

const Title = styled.h2`
  font-size: ${(props) => props.theme.fontxxl};
  text-transform: capitalize;
  width: 80%;
  color: ${(props) => props.theme.text};
  align-self: flex-start;

  span {
    text-transform: uppercase;
    font-family: "Akaya Telivigala", cursive;
  }
  .text-1 {
    color: blue;
  }
  .text-2 {
    color: orange;
  }
  .text-3 {
    color: red;
  }

  @media (max-width: 70em) {
    font-size: ${(props) => props.theme.fontxl};
  }
  @media (max-width: 48em) {
    align-self: center;
    text-align: center;
  }
  @media (max-width: 40em) {
    width: 90%;
  }
`;

const Div = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 10px 0;

  p {
    color: ${(props) => `rgba(${props.theme.textRgba}, 0.6)`};
    font-size: ${(props) => props.theme.fontlg};
    font-weight: 600;
    margin-bottom: 0;
  }
  p span {
    color: orange;
  }
  @media (max-width: 64em) {
    width: 85%;
    flex-direction: column;
  }
  @media (max-width: 48em) {
    width: 100%;
    flex-direction: column;
    align-self: center;
    text-align: center;
  }
`;

const Div2 = styled.div`
  width: 45%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-top: 50px;

  p {
    color: ${(props) => `rgba(${props.theme.textRgba}, 0.6)`};
    font-size: ${(props) => props.theme.fontlg};
    font-weight: 600;
    margin-bottom: 0;
  }
  button {
    margin: 10px 0;
    width: 100%;
    padding: 20px;
    border-radius: 20px;
    background-color: black;
    color: white;
    border: none;
    cursor: pointer;
  }
  @media (max-width: 64em) {
    width: 85%;
    flex-direction: column;
  }
  @media (max-width: 48em) {
    width: 85%;
    flex-direction: column;
    align-self: center;
    text-align: center;
  }
`;

const UserTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 30px;

  th,
  td {
    border: 1px solid #ddd;
    padding: 12px;
    text-align: left;
    color: ${(props) => props.theme.text};
  }

  th {
    background-color: ${(props) => props.theme.body};
    font-weight: bold;
  }

  tr:nth-child(even) {
    background-color: ${(props) => props.theme.bodyRgba};
  }

  tr:hover {
    background-color: ${(props) => props.theme.bodyRgba};
  }

  @media (max-width: 48em) {
    font-size: 14px;
    th,
    td {
      padding: 8px;
    }
  }
`;

const ActionsContainer = styled.div`
  width: auto;
  display: flex;
  gap: 10px;
  justify-content: center;
  flex-direction: column;
  align-items: start;
`;

const Actions = ({ onUpdate, onDelete }) => {
  return (
    <ActionsContainer>
      <Btn onClick={onUpdate}>UPDATE</Btn>
      <Btn onClick={onDelete}>DELETE</Btn>
    </ActionsContainer>
  );
};

const ManageClubs = () => {
    const { user: authUser } = useAuth(); // Get auth user from context
    const [userProfile, setUserProfile] = useState(null);
    const [clubs, setClubs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [selectedClub, setSelectedClub] = useState(null);
  
    // Fetch user profile and clubs data
    useEffect(() => {
      const fetchData = async () => {
        if (!authUser?.$id) return;
  
        try {
          setLoading(true);
          
          // Fetch user profile to check admin role
          const userData = await getUserByDocument(authUser.$id);
          setUserProfile(userData);
          
          // Fetch all clubs
          const allClubs = await getAllClub();
          setClubs(allClubs);
          
        } catch (error) {
          console.error("Error fetching data:", error);
          toast.error("Failed to load clubs data");
        } finally {
          setLoading(false);
        }
      };
  
      fetchData();
    }, [authUser?.$id]);
  
    const handleOpenUpdate = (club) => {
      setSelectedClub(club);
      setIsUpdateModalOpen(true);
    };
  
    const handleOpenDelete = (club) => {
      setSelectedClub(club);
      setIsDeleteModalOpen(true);
    };
  
    const handleUpdateClub = async (updatedClub) => {
      console.log("Updating club:", updatedClub);
      try {
        await updateClub(updatedClub.$id, updatedClub);
        setIsUpdateModalOpen(false);
        
        // Refetch clubs to show updated data
        const allClubs = await getAllClub();
        setClubs(allClubs);
        
        toast.success("Club updated successfully!");
      } catch (error) {
        console.error("Update error:", error);
        toast.error("Error updating club");
      }
    };
  
    const handleDeleteClub = async (clubToDelete) => {
      try {
        await deleteClub(clubToDelete.$id);
        setIsDeleteModalOpen(false);
        
        // Refetch clubs after deletion
        const allClubs = await getAllClub();
        console.log(allClubs)
        setClubs(allClubs);
        
        toast.success("Club deleted successfully!");
      } catch (error) {
        console.error("Delete error:", error);
        toast.error("Error deleting club");
      }
    };
  
    // Show loading state
    if (loading) {
      return (
        <Section id="clubs">
          <Navigation />
          <Container>
            <div style={{ textAlign: 'center', padding: '2rem' }}>
              <LoaderIcon width="40" />
              <p>Loading clubs...</p>
            </div>
          </Container>
          <Footer />
        </Section>
      );
    }
  
    // Check if user is admin
    const isAdmin = userProfile?.role === "admin";
  
    return (
      <Section id="clubs">
        <Navigation />
        {isAdmin ? (
          <Container2>
            <Title>Trade Millennia Clubs</Title>
            
            {clubs.length === 0 ? (
              <div style={{ textAlign: 'center', padding: '2rem' }}>
                <p>No clubs found.</p>
                <Link to="/new-clubs">
                  <button>Create First Club</button>
                </Link>
              </div>
            ) : (
              <UserTable>
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Name</th>
                    <th>Description</th>
                    <th>Chain</th>
                    <th>Floor Price</th>
                    <th>Acceptance Rate (%)</th>
                    <th>Banner</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {clubs.map((club, index) => (
                    <tr key={club.$id || index}>
                      <td>{index + 1}</td>
                      <td>{club.name ?? "Untitled Club"}</td>
                      <td style={{ maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {club.description ?? "No description"}
                      </td>
                      <td>{club.chain ?? "N/A"}</td>
                      <td>{club.floorPrice ?? "N/A"}</td>
                      <td>{club.acceptanceRate ?? 0}%</td>
                      <td>
                        {club.img ? (
                          <img 
                            src={club.img} 
                            alt={club.name} 
                            width="100" 
                            height="60" 
                            style={{
                              objectFit: 'cover',
                              borderRadius: '4px'
                            }} 
                          />
                        ) : (
                          <div style={{
                            width: '100px',
                            height: '60px',
                            backgroundColor: '#f0f0f0',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            borderRadius: '4px',
                            fontSize: '12px',
                            color: '#666'
                          }}>
                            No Image
                          </div>
                        )}
                      </td>
                      <td>
                        <Actions
                          onUpdate={() => handleOpenUpdate(club)}
                          onDelete={() => handleOpenDelete(club)}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </UserTable>
            )}
  
            {isUpdateModalOpen && selectedClub && (
              <UpdateClubModal
                club={selectedClub}
                onClose={() => setIsUpdateModalOpen(false)}
                onSave={handleUpdateClub}
              />
            )}
  
            {isDeleteModalOpen && selectedClub && (
              <DeleteConfirmationModal
                user={selectedClub}
                onClose={() => setIsDeleteModalOpen(false)}
                onConfirm={handleDeleteClub}
              />
            )}
          </Container2>
        ) : (
          <Container>
            <Div>
              <Title>
                <span>Access</span> <span className="text-3">Denied</span>
              </Title>
              <p>
                <Link to="/">Home</Link>
                <span> . Manage Clubs</span>
              </p>
            </Div>
            <Div2>
              <p>You need administrator privileges to access this page.</p>
              <Link to="/dashboard">
                <button>Go to Dashboard</button>
              </Link>
            </Div2>
          </Container>
        )}
        <Footer />
      </Section>
    );
  };

export default ManageClubs;
